import React from "react";
import HomeNavBar from "../Components/HomeNavBar/HomeNavBar";
import Footer from "../Components/Footer/Footer";
import VerticalFarming from "../Components/VerticalFarming/VerticalFarming";

const VerticalFarmingPage = () => {
      return (
      <div>
            <HomeNavBar/>
            <VerticalFarming />
            <Footer />
      </div>
);
};

export default VerticalFarmingPage;